import { Card, CardContent, Divider, Grid, Typography } from '@mui/material'
import { GreenText, LabelField, LoadingContent } from 'components'
import { CANOwnershipDto } from 'dtos/vehicles/titles'
import { formatDateMoment } from 'utils'

interface Props {
  isLoading: boolean
  values?: CANOwnershipDto
}

export default function CANOwnershipDetailsCard({ isLoading, values }: Props) {
  return (
    <Card variant='outlined'>
      <CardContent>
        <Grid container spacing={1} alignItems='flex-start'>
          <Grid item xs={12} container alignItems='center' justifyContent='space-between'>
            <Grid item xs={12} sm='auto'>
              <Typography fontWeight='bold' variant='h5'>
                CAN Ownership
              </Typography>
            </Grid>
          </Grid>

          <Grid item xs={12}>
            <Divider />
          </Grid>

          <LoadingContent isLoading={isLoading}>
            <Grid item xs={12}>
              <LabelField label='Name' value={values?.canOwnershipName} />
            </Grid>

            <Grid item xs={12}>
              <LabelField label='Address' value={values?.canOwnershipAddress1} />
            </Grid>

            <Grid item xs={12}>
              <LabelField label='City' value={values?.canOwnershipCity} />
            </Grid>

            <Grid item xs={12}>
              <LabelField label='Province' value={values?.canOwnershipProvince} />
            </Grid>

            <Grid item xs={12}>
              <LabelField label='Postal Code' value={values?.canOwnershipPostalCode} />
            </Grid>

            <Grid item xs={12}>
              <LabelField
                label='Application Info Last Saved'
                value={
                  values?.applicationPacketUpdatedDateTime
                    ? `${formatDateMoment(values.applicationPacketUpdatedDateTime)} by ${values?.applicationPacketUpdatedByPerson ?? '<User>'}`
                    : undefined
                }
              />
            </Grid>

            <Grid item xs={12}>
              <LabelField
                label='Application Packet Ready to Print'
                value={
                  values?.applicationPacketReadyToPrintDateTime
                    ? `${formatDateMoment(values.applicationPacketReadyToPrintDateTime)} by ${values.applicationPacketReadyToPrintByPerson ?? '<User>'}`
                    : undefined
                }
              />
            </Grid>
          </LoadingContent>

          <Grid item xs={12}>
            <GreenText variant='outlined'>
              {`**CAN Ownership:**

Clicking The “CAN Ownership” card is populated with the
name and address from the OCR’d and accepted
CAN Ownership document associated with the
vehicle. If the CAN Ownership document is from
Quebec, only the Name field will be populated, as
Quebec CAN Ownership documents do not display
address information. For CAN Ownership documents
from Ontario, both the Name and Address fields will
be populated.the EDIT button opens the Edit Cluster Information dialog.

**Application Info Last Saved:**

This section is populated when a user on the
Michigan Titles screen clicks the “Save” button for
the Michigan Title Application Packet.

**Application Packet Ready to Print:**

This section is populated when a user on the
Michigan Titles screen clicks “Save And Mark
Application Packet Ready to Print.”`}
            </GreenText>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  )
}
